export const actions = {
  FULL_FITMENT: 'FullFitment',
  PARTIAL_FITMENT: 'PartialFitment',
  NO_FITMENT: 'NoFitment'
};
